<template>
  <div id="knowledge">
    <v-container grid-list-xl px-4>
      <KnowldgeCard />
    </v-container>
  </div>
</template>

<script>
import KnowldgeCard from '@/components/knowledge/KnowledgeCard'
export default {
  name: 'knowledge',
  components: {
    KnowldgeCard
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
